import { getStripeSetupNotice } from './stripeSetupNotice';
import { STRIPE_SETUP } from './stripeSetupState';

/** Presentation only: notification counts never change payment authorization. */
export function selectPaymentNotice(state, notifications = { phase: 'unknown' }) {
  if (!state) return null;
  const status = state.paymentStatus;
  const base = getStripeSetupNotice({ ...state, status });
  const protectedStatus = state.accountConflict || [STRIPE_SETUP.UNAVAILABLE, STRIPE_SETUP.SYNC_DELAYED].includes(status);
  const hasRequests = notifications.actionRequired > 0;
  let notice = base;
  if (!protectedStatus && (state.additionalInformationRequired || hasRequests)) {
    const capabilities = state.chargesEnabled
      ? state.payoutsEnabled === false ? 'You can accept donations. Payouts are not enabled.' : 'You can still accept donations.'
      : state.payoutsEnabled === false ? 'Payments and payouts are not enabled.' : 'Payments are not enabled.';
    notice = {
      title: state.chargesEnabled ? 'Your Stripe account needs attention' : 'Payment account needs attention',
      description: `${capabilities} ${state.additionalInformationRequired ? 'Stripe needs additional information.' : 'Review Stripe’s outstanding requests.'}`,
      buttonLabel: 'Review requirements', action: 'review', attention: true,
    };
  } else if (!protectedStatus && [STRIPE_SETUP.RESTRICTED, STRIPE_SETUP.PAYOUT_PENDING].includes(status)) {
    notice = { ...base, buttonLabel: 'Review payment account', destination: undefined, action: 'review' };
  } else if (!protectedStatus && notifications.total > 0 && [STRIPE_SETUP.READY, STRIPE_SETUP.REVIEW_PENDING, STRIPE_SETUP.SUBMITTED].includes(status)) {
    notice = { title: 'Stripe account update', description: 'Stripe has an update for your account. Review the details for more information.', buttonLabel: 'Review details', action: 'review' };
  } else if (!base && state.showPaymentReadyNotice && notifications.phase === 'ready') {
    notice = { title: 'Payments enabled', description: 'Your account is ready to accept donations. Publish your forms when you’re ready to share them.', statusLabel: 'Ready to accept donations' };
  }
  return notice ? { ...notice, reconnecting: state.stale || notifications.phase === 'error' } : null;
}

export function validNotificationCounts(value) {
  return value && Number.isInteger(value.total) && Number.isInteger(value.actionRequired)
    && value.total >= 0 && value.actionRequired >= 0 && value.actionRequired <= value.total;
}
